import React, { useEffect, useState } from "react";
import { getNotificationChannels } from "@api/merchantsController";
import { useBranches } from "@api/branchesController";
import { PageHeader, PageTitle, Button, Input, SimpleTable } from "@components";
import {
  SectionHeader,
  SectionTitle,
  SectionTagline,
  ControlStrip,
} from "../components";
import AddSharedMailbox from "../modals/AddSharedMailbox";
import EditSharedMailbox from "../modals/EditSharedMailbox";
import DeleteSharedMailbox from "../modals/DeleteSharedMailbox";
import { PlusLg } from "react-bootstrap-icons";
import { useUser, useMerchant } from "@auth";

function SharedMailboxes() {
  const { user } = useUser();
  const { merchant } = useMerchant();
  const [addMailboxIsOpen, setAddMailboxIsOpen] = useState(false);
  const [editMailboxDetails, setEditMailboxDetails] = useState(null);
  const [deleteMailboxDetails, setDeleteMailboxDetails] = useState(null);
  const [channels, setChannels] = useState(null);
  const { data: branches = [] } = useBranches();

  useEffect(() => {
    fetchChannels();
  }, []);

  async function fetchChannels() {
    const data = await getNotificationChannels();
    const sortedData = data.sort((a, b) => a.name.localeCompare(b.name));
    setChannels(sortedData);
  }

  const tableConfig = () => {
    return {
      rowActions: [
        {
          label: "Edit",
          onClick: (x) => setEditMailboxDetails(x),
        },
        {
          label: "Remove",
          onClick: (x) => setDeleteMailboxDetails(x),
        },
      ],
      columns: [
        {
          title: "Name",
          width: "144px",
          render: (x) => x.name,
        },
        {
          title: "Email",
          width: "500px",
          render: (x) => x.emailAddress,
        },
      ],
    };
  };

  const onComplete = () => {
    fetchChannels();
    setAddMailboxIsOpen(false);
    setEditMailboxDetails(null);
    setDeleteMailboxDetails(null);
  };

  return (
    <div className="flex flex-col items-center py-4 px-5 border-b border-zinc-200">
      <div className="py-8 w-full max-w-4xl">
        <SectionHeader>
          <SectionTitle>Shared mailboxes</SectionTitle>
          <SectionTagline>
            Configure additional emails to receive notifications from Ontik
          </SectionTagline>
          {user.memberships.length > 1 && (
            <SectionTagline>
              These changes apply to your account with <b>{merchant.name}</b>
            </SectionTagline>
          )}
        </SectionHeader>
        <ControlStrip>
          <Button onClick={() => setAddMailboxIsOpen(true)} color="primary">
            <PlusLg className="mr-2" />
            Add inbox
          </Button>
        </ControlStrip>
        <SimpleTable config={tableConfig()} data={channels} extraCol />
        <AddSharedMailbox
          open={addMailboxIsOpen}
          onClose={() => setAddMailboxIsOpen(false)}
          onComplete={onComplete}
          branches={branches}
        />
        {!!editMailboxDetails && (
          <EditSharedMailbox
            editMailboxDetails={editMailboxDetails}
            onClose={() => setEditMailboxDetails(null)}
            onComplete={onComplete}
            branches={branches}
          />
        )}
        {!!deleteMailboxDetails && (
          <DeleteSharedMailbox
            mailbox={deleteMailboxDetails}
            open={!!deleteMailboxDetails}
            onClose={() => setDeleteMailboxDetails(null)}
            onComplete={onComplete}
          />
        )}
      </div>
    </div>
  );
}

export default SharedMailboxes;
